import React from "react"; // Importing React library

// Delete component for confirming record deletion
export default function Delete({ formData, onDiscard, handleSubmit }) {
  return (
    <>
      <div className="container form-group text-center text-secondary col-sm-8 pt-5">
        {/* Confirmation message asking user to confirm deletion */}
        <h3 className="row justify-content-md-center">
          Are you sure you want to delete this record?
          {/* Displaying the name of the campaign to be deleted */}
          <b>
            <u>{formData.campaign_name}</u>
          </b>
        </h3>

        <div className="mt-4">
          {/* Submit button to confirm deletion */}
          <input
            type="submit" // Input of type submit
            value="Yes" // Text for the button
            className="btn bg-orange form-btn" // CSS classes for styling
            onClick={handleSubmit} // Handler for confirming deletion
          />
          &nbsp; {/* Adding space between buttons */}
          {/* Button to discard the deletion confirmation */}
          <div className="btn btn-secondary form-btn mx-3" onClick={onDiscard}>
            No
          </div>
        </div>
      </div>
    </>
  );
}
